import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
	dsn: SENTRY_DSN || 'https://36ead324121e4fa3816fa38859594118@o577392.ingest.sentry.io/5904760',
	tracesSampleRate: 1.0,
});
